<template>
    <v-dialog v-model="dialog" max-width="1024px">
        <v-card>
            <v-card-title primary-title class="title">
                AGB der {{organizer.name}}
            </v-card-title>
            <v-card-text v-html="organizer.terms">
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="dialog=false">{{__('general.close')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "Terms",
        props: {
            organizer: Object,
        },
        computed: {
            dialog: {
                get() {
                    return this.$store.state.terms;
                },
                set(v) {
                    this.$store.commit('setTerms', v);
                }
            }
        }
    }
</script>

<style scoped>

</style>
